import React from "react";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { useStats } from "../apiCalls/statsApiCalls";
import { Container } from "./ui";
import { formatNumber, getCountryName } from "../utils";

// The navy section in the home page's rhythm (§17). Counts are aggregated from
// active players' nationality — no invented figures.
const WorldBand = () => {
  const { data } = useStats();
  const countries = data?.data?.topCountries ?? [];

  if (countries.length === 0) return null;

  return (
    <section className="bg-navy py-16 md:py-20">
      <Container>
        <div className="mb-8 flex flex-col gap-2 text-center">
          <h2 className="text-2xl font-bold tracking-tight text-white md:text-3xl">
            Padel Around the World
          </h2>
          <p className="text-sm text-white/60">
            Where the ranked field plays. {formatNumber(data?.data?.countries)}{" "}
            countries represented.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {countries.map((entry) => (
            <Link
              key={entry.country}
              to={`/rankings?country=${entry.country}`}
              className="flex flex-col items-center gap-2 rounded-md border border-white/10 bg-white/5 px-4 py-6 transition-colors hover:border-white/25 hover:bg-white/10"
            >
              <ReactCountryFlag
                countryCode={entry.country}
                svg
                style={{ width: "2.25em", height: "2.25em", borderRadius: "4px" }}
                aria-hidden="true"
              />
              <span className="mt-1 text-center text-sm font-semibold text-white">
                {getCountryName(entry.country)}
              </span>
              <span className="tabular text-2xl font-bold text-primary-hover">
                {formatNumber(entry.players)}
              </span>
              <span className="text-xs text-white/50">Ranked Players</span>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WorldBand;
